import { FC, useEffect, useState } from "react";
import PolicyItem from "components/PrivacyPolicyListing/PolicyItem";
import Seo from "components/Seo/Seo";
import { getAllAboutUsSections } from "services/api";
import { IAboutUsSection } from "services/models/index";

const AboutPage: FC<any> = () => {
  const [sections, setSections] = useState<IAboutUsSection[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllAboutUsSections()
      .then((data: any) => {
        setSections(data);
        setLoading(false);
      })
      .catch((err: any) => {
        setError("Failed to fetch About Us sections");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  // Sort sections by order
  sections.sort((a, b) => (a.order || 0) - (b.order || 0));
  // Map sections to the existing texts structure
  const texts = sections.map((section) => ({
    title: section.title,
    text: section.text,
    icon: "question-circle", // Assuming you want to keep the same icon for all sections
  }));

  return (
    <div
      className={`nc-PageAbout overflow-hidden relative`}
      data-nc-id="PageAbout"
    >
      <Seo
        name="About Page | Orbito Travel"
        description="Discover our commitment to inclusive travel at Orbito Travel. Join our mission for equal opportunities in tourism. Learn how we empower travelers with reduced mobility. Start exploring with us today!"
        title="About Page | Orbito Travel"
        type="page"
      />
      <div className="container py-16 space-y-16 lg:space-y-28">
        <div className="w-screen max-w-full">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 mb-8">
            About
          </h2>
          <div className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            <PolicyItem texts={texts} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
